import type { Service } from '~/types/Service'

export const createBlankNewService = () => {
  const newService: Required<Service> = {
    // defaults - make sure no arrays with values as we defu merge these
    // if you need to add arrays with values, then we'll need to make a custom defu to merge them
    uid: '',
    languageOptionsTextHtml: '',
    internalCorrespondenceEmails: [],
    adminUsers: [],
    amountOfNotes: 0,
    catchmentArea: '',
    coordinates: { lat: 51.509865, lng: -0.118092 },
    descriptionHtml: '',
    hasParkingFacilities: false,
    hasToilets: false,
    isLocalAuthorityProvider: false,
    localAuthorityText: '',
    isNationalProvider: false,
    isNHSProvider: false,
    hasFreeParkingFacilities: false,
    hasVisualAids: false,
    hasHearingAndAuditoryAids: false,
    hasTextRelay: false,
    hasBSL: false,
    hasAccessibleWebsite: false,
    forStudents: false,
    forCarersAndFamilies: false,
    forFrontlineWorkers: false,
    isPrisonAndProbationFriendly: false,
    involvesPhysicalActivityAndMovement: false,
    isEpilepsyFriendly: false,
    isTraumaFriendly: false,
    isPrivateProvider: false,
    isPrivateSectorPaidProvider: false,
    isPrivateSectorFreeProvider: false,
    isVCSEProvider: false,
    maxAge: 0,
    minAge: 0,
    ageVerified: false,
    name: '',
    offersEthnicSupport: false,
    offersInPersonSupport: false,
    offersLanguageOptions: false,
    offersVirtualServices: false,
    offersOnlineSupport: false,
    offersLgbtqSupport: false,
    offersMensSupport: false,
    offersWomensSupport: false,
    offersPeerGroupSupport: false,
    offersSmsSupport: false,
    offersTelephoneSupport: false,
    offersTravellerSupport: false,
    offersWalkins: false,
    offersWheelChairAccess: false,
    hasReferralProcess: false,
    open247: false,
    openingTimesType: 'standard',
    completelyIrregularHoursText: '',
    openingTimes: {
      monday: {
        hasIrregularHours: false,
        irregularHoursText: '',
        isClosed: true,
        open24Hours: false,
        openingHours: []
      },
      tuesday: {
        hasIrregularHours: false,
        irregularHoursText: '',
        isClosed: true,
        open24Hours: false,
        openingHours: []
      },
      wednesday: {
        hasIrregularHours: false,
        irregularHoursText: '',
        isClosed: true,
        open24Hours: false,
        openingHours: []
      },
      thursday: {
        hasIrregularHours: false,
        irregularHoursText: '',
        isClosed: true,
        open24Hours: false,
        openingHours: []
      },
      friday: {
        hasIrregularHours: false,
        irregularHoursText: '',
        isClosed: true,
        open24Hours: false,
        openingHours: []
      },
      saturday: {
        hasIrregularHours: false,
        irregularHoursText: '',
        isClosed: true,
        open24Hours: false,
        openingHours: []
      },
      sunday: {
        hasIrregularHours: false,
        irregularHoursText: '',
        isClosed: true,
        open24Hours: false,
        openingHours: []
      }
    },
    referralDescriptionHtml: '',
    socialLinks: {
      facebook: { isActive: false, url: '' },
      instagram: { isActive: false, url: '' },
      linkedin: { isActive: false, url: '' },
      x: { isActive: false, url: '' }
    },
    streetViewConfig: { heading: 0, pitch: 0, zoom: 0, coordinates: { lat: 0, lng: 0 } },
    charityNumber: '',
    helplineTel: '',
    legacyUid: '',
    logoUrl: '',
    companyNumber: '',
    officeTelephoneNumber: '',
    contacts: [],
    location: {
      physicalAddress: {
        address1: '',
        address2: '',
        postalCode: '',
        city: '',
        country: 'United Kingdom', // default
        county: '',
        isVisibleToPublic: true
      }
    },
    network: '',
    status: 'active',
    supportNeedCategories: [],
    url: '',
    requesterEmail: '',

    // absolute
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }

  return newService
}
